<template>
    <div ref="myPage" @scroll="f_scroll_change($event)">
        <div :style="{height: $store.state.datas.header.height + 'px'}"></div>
        <template v-if="$store.state.datas.pages[this.$route.name]">
            <components v-for="(item,index) in $store.state.datas.pages[this.$route.name].composants" :key="index" :is="item.name" :data-provider="item"></components>
        </template>
        <div class="my-2"  v-if="scrollExist" style="position: fixed;bottom: 50px;right: 20px" @click="goToTop">
            <v-btn color="grey" fab dark>
                <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
        </div>
        <div style="height: 36px"></div>
    </div>
</template>
<script>
    export default {
        name: "vx-main",
        data() {
            return {
                scrollExist: false
            }
        },
        methods: {
            goToTop() {
                this.$refs.myPage.scrollTop = 0
                /*this.$vuetify.goTo(this.$refs.myPage, {
                    duration: 500,
                    offset: 0,
                    easing: 'easeInOutCubic',
                })*/
            },
            f_scroll_change (e) {
                if (parseInt(e.target.scrollTop) > 0) {
                    this.scrollExist = true
                } else {
                    this.scrollExist = false
                }
            }
        }
    }
</script>
